module.exports = __webpack_public_path__ + "img/id.fe472b0b.png";